module.exports = __webpack_public_path__ + "static/internet-97c7bbb7097d7d636139ef60b8ebfe21.jpg";